module.exports = __webpack_public_path__ + "img/sound_hover.0b25a5e8.svg";